import { PatientKind } from "common/types";

import { ProductLineSearchFilters, SelectedCategoryProductLineFilters } from "../types";
import SearchFilterTags from "./SearchFilterTags";

type CategoryProductLineSearchFilterTagsProps = {
  options: ProductLineSearchFilters;
  value: SelectedCategoryProductLineFilters;
  onChange: (value: SelectedCategoryProductLineFilters) => void;
};

const CategoryProductLineSearchFilterTags = ({
  options,
  value,
  onChange,
}: CategoryProductLineSearchFilterTagsProps) => {
  return (
    <>
      <SearchFilterTags<PatientKind>
        options={options.species}
        value={value.species}
        onChange={(species) =>
          onChange({
            ...value,
            species,
          })
        }
      />
      <SearchFilterTags
        options={options.manufacturers}
        value={value.manufacturer_ids}
        onChange={(manufacturer_ids) => onChange({ ...value, manufacturer_ids })}
      />
    </>
  );
};

export default CategoryProductLineSearchFilterTags;
